export = {
  TYPE_UNKNOWN: 0,
  TYPE_LEAGUE: 1,
  TYPE_CUP: 2,
  TYPE_FRIENDLY: 3,
}
